<template>
  <section class="services" id="services">
    <div class="services-container">
      <div class="service-card" v-for="(service, index) in services" :key="index">
        <h3>{{ $t(service.titleKey) }}</h3>
        <ul>
          <li v-for="(feature, fIndex) in service.features" :key="fIndex">
            {{ $t(feature) }}
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup>
const services = [
  {
    titleKey: 'services.personalizedTraining.title',
    features: [
      'services.personalizedTraining.features.0',
      'services.personalizedTraining.features.1',
      'services.personalizedTraining.features.2'
    ]
  },
  {
    titleKey: 'services.videoGuides.title',
    features: [
      'services.videoGuides.features.0',
      'services.videoGuides.features.1',
      'services.videoGuides.features.2'
    ]
  },
  {
    titleKey: 'services.dedicatedSupport.title',
    features: [
      'services.dedicatedSupport.features.0',
      'services.dedicatedSupport.features.1'
    ]
  },
  {
    titleKey: 'services.realTimeMonitoring.title',
    features: [
      'services.realTimeMonitoring.features.0',
      'services.realTimeMonitoring.features.1'
    ]
  },
  {
    titleKey: 'services.expertConsulting.title',
    features: [
      'services.expertConsulting.features.0',
      'services.expertConsulting.features.1'
    ]
  },
  {
    titleKey: 'services.technicalSupport.title',
    features: [
      'services.technicalSupport.features.0',
      'services.technicalSupport.features.1',
      'services.technicalSupport.features.2'
    ]
  },
  {
    titleKey: 'services.iftaReports.title',
    features: [
      'services.iftaReports.features.0',
      'services.iftaReports.features.1',
      'services.iftaReports.features.2'
    ]
  },
  {
    titleKey: 'services.documentStorage.title',
    features: [
      'services.documentStorage.features.0',
      'services.documentStorage.features.1',
      'services.documentStorage.features.2'
    ]
  },
  {
    titleKey: 'services.customizedSupport.title',
    features: [
      'services.customizedSupport.features.0',
      'services.customizedSupport.features.1',
      'services.customizedSupport.features.2'
    ]
  },
  {
    titleKey: 'services.onSiteSetup.title',
    features: [
      'services.onSiteSetup.features.0',
      'services.onSiteSetup.features.1',
      'services.onSiteSetup.features.2'
    ]
  }
]
</script>

<style scoped>
.services {
  padding: 4rem 2rem;
  background-color: #f5f5f5;
}

.services-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.service-card {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid #e0e0e0;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.service-card h3 {
  color: #1a1a1a;
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: 600;
}

.service-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.service-card li {
  margin-bottom: 0.5rem;
  color: #424242;
  position: relative;
  padding-left: 1.5rem;
}

.service-card li::before {
  content: "•";
  color: #1a1a1a;
  position: absolute;
  left: 0;
}

@media (max-width: 768px) {
  .services {
    padding: 2rem 1rem;
  }
  
  .services-container {
    grid-template-columns: 1fr;
  }
}
</style> 